import React, { useEffect, useState } from "react";
import rsfservice from "../../../../services/rsfservice";
import { Offcanvas, Table } from "react-bootstrap";
import AllOrdersDetails from "./AllOrdersDetails";

const AllOrder = () => {
  const [orders, setOrders] = useState([]);
  const [show, setShow] = useState(false);
  const [activeData, setActiveData] = useState(null);

  const handleClose = () => {
    setActiveData(null);
    setShow(false);
  };
  const handleShow = (item) => {
    setActiveData(item);
    setShow(true);
  };

  const FetchAllOrders = async () => {
    const response = await rsfservice.getOrders();
    setOrders(response);
  };

  useEffect(() => {
    FetchAllOrders();
  }, []);

  return (
    <div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Order ID</th>
            {/* <th>Order From</th> */}
            <th>Order To</th>            
            <th>Domain</th>
            <th>Collected By</th>
          </tr>
        </thead>
        <tbody>
          {orders.data &&
            orders.data.length > 0 &&
            orders.data.map((data, index) => (
              <tr
                key={index}
                onClick={() => handleShow(data)}
                className={data._id === activeData?._id ? "table-primary" : ""}
              >
                <td>{data.orderId}</td>
                {/* <td>{data.orderFrom}</td> */}
                <td>{data.orderTo}</td>
                <td>{data.domain}</td>
                <td>{data.collected_by}</td>
              </tr>
            ))}
        </tbody>
      </Table>

      {show && (
        <Offcanvas show={show} onHide={handleClose} className="w-75">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Transaction Details</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <h5 className="mb-4">Details of the Selected Transaction</h5>
            <AllOrdersDetails details={activeData} />
          </Offcanvas.Body>
        </Offcanvas>
      )}
    </div>
  );
};

export default AllOrder;
